import * as React from 'react';
import { styled } from '../../../../theme';
import { BreadCrumbWidget, BreadCrumbWidgetProps } from '../../../../widgets/header/BreadCrumbWidget';

namespace S {
  export const MFABreadCrumbContainer = styled.div`
    display: flex;
    justify-content: center;
  `;

  export const MFABreadCrumb = styled(BreadCrumbWidget)`
    max-width: 300px;
  `;
}

export const MFAFormContent = styled.div`
  min-height: 250px;
  min-width: 400px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MFABreadCrumb: React.FC<BreadCrumbWidgetProps> = (props) => {
  return (
    <S.MFABreadCrumbContainer>
      <S.MFABreadCrumb {...props} />
    </S.MFABreadCrumbContainer>
  );
};
